<script lang="ts">
  import clsx from 'clsx'
  import componentAttributes from '../../../../stores/componentAttributes.svelte'
  import { getProgressBarContext } from '../progressBarContext'
  import { THEMES } from '../../../../const/themes'

  type Props = {
    progressionParts: { left: number; width: number }[]
  }

  let { progressionParts }: Props = $props()

  const progressBarContext = getProgressBarContext()
</script>

{#each progressionParts as part}
  <div
    class={clsx('absolute top-0 left-0 h-full', {
      'duration-300 ease-linear':
        !progressBarContext.isDragging && progressBarContext.isSmooth,
    })}
    style={`left: ${part.left}%; width: ${part.width}%; background-color: ${componentAttributes.state.progressBarColor || componentAttributes.state.primaryColor || THEMES.DEFAULT.PROGRESS_BAR_COLOR}`}
  ></div>
{/each}
